import {
  ErrorType,
  MappedError,
} from "Components/Form/ErrorsSummedUp/interfaces";
import { FormikErrors, FormikProps } from "formik";
import { isDefined, isUndefined } from "./functions";

import { Option } from "@storeblocks/select";
import { FormText } from "Components/Features/CheckPrice/Products/productInterfaces";
import { getComponentTextByFieldId } from "Components/TextContext";
import { Data } from "Components/TextContext/textInterfaces";
import { ErrorPrefix } from "Constants/constants";
import { Company } from "Store/companies/interfaces";
import { BooleanFormType } from "Store/interfaces/FormTypes";

export const nullableBooleanToNullableFormBoolean = (
  value: boolean | undefined | null,
): BooleanFormType | undefined =>
  isDefined(value) ? booleanToFormBoolean(value) : undefined;

export const nullableFormBooleanToNullableBoolean = (
  value: string | undefined,
): boolean | undefined =>
  isUndefined(value) ? undefined : formBooleanToBoolean(value);

export const booleanToFormBoolean = (value: boolean): BooleanFormType =>
  value ? BooleanFormType.TRUE : BooleanFormType.FALSE;

export const formBooleanToBoolean = (value: string | undefined): boolean =>
  value === BooleanFormType.TRUE;

export const companyListToSelectFormList = (
  list: Company[] | null,
): Option[] => {
  return [
    { label: "-- Velg fra listen --", value: "" },
    ...(list
      ? Array.from(
          list.map(
            (company: Company): Option => ({
              label: company.name,
              value: company.name,
            }),
          ),
        )
      : []),
  ];
};

const removePrefixFromErrorMessage = (errorMessage: string): string => {
  return Object.values(ErrorPrefix).reduce(
    (finalString, errorPrefix) => finalString.replace(errorPrefix, ""),
    errorMessage,
  );
};

//TODO: rename: remove "Ditto" after all products have implemented Ditto and mapValidationErrors is deleted
export const mapValidationErrorsDitto = (
  formErrors: FormikErrors<any>,
  shortTitles: Data[],
): MappedError[] => {
  return Object.entries(formErrors).map((entry) => {
    const [key, value] = entry;

    return {
      errorMessage: removePrefixFromErrorMessage(String(value)),
      errorLabel: getComponentTextByFieldId(shortTitles, key) ?? "",
      type: String(value).startsWith(ErrorPrefix.BREAKING)
        ? ErrorType.BREAKING
        : ErrorType.VALIDATION,
      id: key,
    };
  });
};

//TODO: delete after all products have implemented Ditto
export const mapValidationErrors = (
  formErrors: FormikErrors<any>,
  formText: FormText,
  lang: string,
): MappedError[] => {
  return Object.entries(formErrors).map((entry) => {
    const [key, value] = entry;
    return {
      errorMessage: removePrefixFromErrorMessage(String(value)),
      errorLabel: formText[key][lang],
      type: String(value).startsWith(ErrorPrefix.BREAKING)
        ? ErrorType.BREAKING
        : ErrorType.VALIDATION,
      id: key,
    };
  });
};

export const addDefaultSelectOption = (
  defaultLabel: string,
  options: Option[],
): Option[] => [{ label: defaultLabel, value: "" }, ...options];

export const setField = async (
  formProps: FormikProps<unknown>,
  name: string,
  value: unknown,
  touched = true,
): Promise<void> => {
  await formProps.setFieldValue(name, value);
  await formProps.setFieldTouched(name, touched);
};

export const checkIfTargetValueIsANumberAndReturnCurrentValueIfNot = (
  currentNumber: string,
  targetValue: string,
  field: any,
): string => {
  const validInput = /^[0-9.]*$/;
  if (targetValue.match(validInput)) {
    return targetValue;
  } else {
    if (field === undefined) {
      return "";
    }
    return currentNumber;
  }
};

export const whenFormIsValid = async <T>(
  formProps: FormikProps<T>,
  formValues: Partial<T>,
): Promise<void> => {
  const formikErrors = await formProps.validateForm(formValues);
  if (Object.entries(formikErrors).length > 0) {
    throw Error("Form is not valid");
  }
};
